import request from '@/utils/request'
// 新增接收人
export function createReceiver(data) {
  return request({
    url: '/stay/createReceiver',
    method: 'post',
    data,
  })
}
export function removeReceiver(data) {
  return request({
    url: '/stay/removeReceiver',
    method: 'post',
    data,
  })
}
export function getReceiverList(params) {
  return request({
    url: '/stay/findReceiverList',
    method: 'get',
    params,
  })
}

// 获取入住记录
export function getStayList(params) {
  return request({
    url: '/stay/findList',
    method: 'get',
    params,
  })
}